<template>
  <div>
    <p
      :style="dataField['style']"
      :class="dataField['class']"
      v-html="dataField['value']"
    ></p>

  </div>
</template>

<script>

export default {
  props: ["dataField"],
  name: "HtmlBox",
  data: () => ({}),
};
</script>
